import type { Rectangle } from '@glideapps/glide-data-grid';

import { Button } from '@simplywallst/ui-core';

import { pluralise } from '@/utilities/pluralise';

interface Props {
  cell: Rectangle | null;
  oldUniqueSymbol: string;
  newUniqueSymbol: string;
  matchRowCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const TickerRematchPopover = ({
  cell,
  oldUniqueSymbol,
  newUniqueSymbol,
  matchRowCount,
  onConfirm,
  onCancel,
}: Props) => {
  if (cell === null) return null;
  const { x, y, width } = cell;

  return (
    <div
      className="absolute bg-p-white-110 p-x2 w-[300px] h-[auto] shadow-lg rounded-md border border-solid border-p-grey-100/5"
      style={{ top: y - 8, left: x + width + 25 }}
    >
      <div className="grid grid-rows-[32px_auto_40px] gap-3">
        <div className="text-base font-strong">
          Update all matching tickers?
        </div>
        <div>
          <p className="mb-1 text-xs text-legacy-darkgray">
            You have {matchRowCount} mathcing{' '}
            {pluralise(matchRowCount, 'ticker', 'tickers')}.{' '}
            {pluralise(matchRowCount, 'Update it ?', 'Update all ?')}
          </p>
          <p className="mb-1 text-xs text-legacy-darkgray">
            <span className="line-through">{oldUniqueSymbol}</span> &rarr;{' '}
            <span>{newUniqueSymbol}</span>
          </p>
        </div>
        <div className="grid gap-3 grid-cols-[max-content_max-content] justify-start">
          <Button styleType="louderLarge" onClick={onConfirm}>
            {pluralise(matchRowCount, 'Update', 'Update all')}
          </Button>
          <Button styleType="gentleLargeReverse" onClick={onCancel}>
            No
          </Button>
        </div>
      </div>
    </div>
  );
};
